

































import { Prop, ProvideReactive } from 'vue-property-decorator'
import { Component, mixins } from '@niknevis/vue-modules'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { ContentItemCollectionType } from '@/modules/content-item/models/content-item-collection.model'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import QTable from 'quasar/src/components/table/QTable.js';
import { getContentItemColumnsInPanel } from '@/modules/content-item/models/columns/content-item.column'
import PanelContentItemTableRow from '@/modules/content-item/components/panel/table/PanelContentItemTableRow.vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import Pagination from '@/modules/shared/components/shared/pagination/Pagination.vue'


@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'آیتم های تولید محتوا',
    page_sub_header: 'در این بخش می‌توانید تمامی مقالات خود را فارغ از کمپین‌های آنها مشاهده و مدیریت نمایید'
  },
  metaInfo: {
    title: 'آیتم های تولید محتوا'
  },
  components: {
    TesTable,
    FilterRow,
    Pagination
  }
})
export default class IndexPage extends mixins(
  QsPaginatableMixin,
  QsSearchableMixin
) {
  @ProvideReactive()
  @Prop() items!: ContentItemCollectionType

  protected columns: QTable['columns'] = getContentItemColumnsInPanel()

  private rowComponent = PanelContentItemTableRow

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت',
      holder: 'درحال اجرا',
      typeMode: false,
      key: 'statuses',
      items: Object.entries(this.items.statuses).map(([key, value]) => ({ label: value, value: key }))
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ تقریبی تحویل',
      holder: 'انتخاب کنید',
      typeMode: false,
      keys: {
        from: 'deliver_at_from',
        to: 'deliver_at_to'
      },
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ]
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ تکمیل',
      holder: 'انتخاب کنید',
      typeMode: false,
      keys: {
        from: 'completed_at_from',
        to: 'completed_at_to'
      },
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ]
    })
  ]

  protected get model(): ContentItemCollectionType {
    return this.items
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
